import { supabase } from "@/integrations/supabase/client";

/**
 * Where on the site a CTA lives — used for attribution in email_analytics.
 */
export type CtaLocation =
  | "home_hero_start"
  | "home_hero_watch_message"
  | "home_story_about"
  | "home_nice_guy_teaser"
  | "home_content_youtube"
  | "home_content_journal"
  | "home_content_instagram_header"
  | "home_content_instagram_follow"
  | "home_content_reel"
  | "home_seven_signs_pdf_fallback"
  | "home_seven_signs_read"
  | "seven_signs_page_header_download"
  | "seven_signs_page_hero_download"
  | "seven_signs_page_cta_download"
  | "other";

/**
 * Fire-and-forget click tracking for landing-page CTAs and content embeds.
 * Writes to email_analytics so it shares one funnel table with newsletter signups.
 */
export const trackCta = (
  location: CtaLocation,
  destination: string,
  label?: string,
) => {
  void supabase.functions.invoke("track-event", {
    body: {
      kind: "analytics",
      event_type: "cta_click",
      campaign_type: "landing_cta",
      campaign_id: location,
      link_url: destination,
      event_data: {
        location,
        destination,
        label: label ?? null,
        path: typeof window !== "undefined" ? window.location.pathname : null,
        referrer: typeof document !== "undefined" ? document.referrer : null,
        user_agent: typeof navigator !== "undefined" ? navigator.userAgent : null,
      },
    },
  })
    .then(({ error }) => {
      if (error) console.error("trackCta failed", error);
    });
};